<template>
  <div>
    <el-row justify="end">
      <el-col :span="4">
        <el-divider content-position="left">車種マスタ設定</el-divider>
      </el-col>
      <el-col :span="20" style="text-align: right">
        <el-button type="primary" @click="openDialog(null)">追加</el-button>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-table
      :data="typeList"
      border
      style="width: 100%; margin-top: 10px"
      :header-cell-style="{
        background: '#08455d',
        color: '#fff',
        fontWeight: 'bold',
      }"
    >
      <el-table-column label="No" width="60" align="center">
        <template v-slot="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column
        prop="code"
        label="コード"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column prop="m_code" label="メーカー" width="290">
        <template v-slot="scope">
          {{ getManufacturerName(scope.row.m_code) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name_ja"
        label="内容 (日本語)"
        width="300"
      ></el-table-column>
      <el-table-column
        prop="name_en"
        label="内容 (英語)"
        width="300"
      ></el-table-column>

      <el-table-column label="操作" align="center" width="200">
        <template v-slot="scope">
          <el-button type="warning" size="small" @click="openDialog(scope.row)"
            >変更</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="deleteType(scope.row.code)"
            >削除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <el-dialog v-model="dialogVisible" :title="editMode ? '編集' : '追加'">
      <el-form label-position="top">
        <el-form-item label="メーカー">
          <el-select v-model="form.m_code" placeholder="メーカーを選択">
            <el-option
              v-for="manufacturer in manufacturers"
              :key="manufacturer.code"
              :label="manufacturer.name_ja"
              :value="manufacturer.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="code">
          <el-input v-model="form.code" required />
        </el-form-item>
        <el-form-item label="内容 (日本語)">
          <el-input v-model="form.name_ja" required />
        </el-form-item>
        <el-form-item label="内容 (英語)">
          <el-input v-model="form.name_en" required />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">キャンセル</el-button>
        <el-button type="primary" @click="saveType">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { supabase } from "@/supabase.js";

export default {
  setup() {
    const typeList = ref([]); // 车种数据
    const manufacturers = ref([]); // 厂商数据
    const dialogVisible = ref(false);
    const editMode = ref(false);
    const form = ref({
      code: null,
      m_code: "",
      name_ja: "",
      name_en: "",
    });

    // 📌 获取所有数据
    const fetchData = async () => {
      const { data: typeData, error: typeError } = await supabase
        .from("model_m")
        .select("*");
      const { data: manufacturerData, error: manufacturerError } =
        await supabase.from("manufacturer_m").select("*");

      if (typeError || manufacturerError) {
        console.error("データ取得エラー:", typeError || manufacturerError);
      } else {
        typeList.value = typeData;
        manufacturers.value = manufacturerData;
      }
    };

    // 📌 获取厂商名称
    const getManufacturerName = (m_code) => {
      const manufacturer = manufacturers.value.find((m) => m.code === m_code);
      return manufacturer ? manufacturer.name_ja : "不明";
    };

    // 📌 打开弹窗（新增/编辑）
    const openDialog = (row) => {
      if (row) {
        form.value = { ...row };
        editMode.value = true;
      } else {
        form.value = { code: "", m_code: "", name_ja: "", name_en: "" };
        editMode.value = false;
      }
      dialogVisible.value = true;
    };

    // 📌 保存数据
    const saveType = async () => {
      if (!form.value.m_code || !form.value.name_ja || !form.value.name_en) {
        ElMessage.error("全ての項目を入力してください。");
        return;
      }

      let response;
      console.log("editMode.value:"+editMode.value)
      if (editMode.value) {
        response = await supabase
          .from("model_m")
          .update(form.value)
          .eq("code", form.value.code);
      } else {
        console.log("form.value:"+form.value)
        response = await supabase.from("model_m").insert(form.value);
      }

      if (response.error) {
        console.error("保存エラー:", response.error);
        ElMessage.error("保存に失敗しました。");
      } else {
        ElMessage.success("データを保存しました。");
        dialogVisible.value = false;
        fetchData();
      }
    };

    // 📌 删除数据
    const deleteType = async (code) => {
      ElMessageBox.confirm("このデータを削除しますか？", "確認", {
        confirmButtonText: "削除",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(async () => {
          const { error } = await supabase
            .from("model_m")
            .delete()
            .eq("code", code);
          if (error) {
            console.error("削除エラー:", error);
            ElMessage.error("削除に失敗しました。");
          } else {
            ElMessage.success("データを削除しました。");
            fetchData();
          }
        })
        .catch(() => {
          ElMessage.info("削除をキャンセルしました。");
        });
    };

    onMounted(fetchData);

    return {
      typeList,
      manufacturers,
      dialogVisible,
      editMode,
      form,
      fetchData,
      getManufacturerName,
      openDialog,
      saveType,
      deleteType,
    };
  },
};
</script>
<style scoped>
.el-divider >>> .el-divider__text {
  background-color: #f5f5f5 !important;
  color: var(--el-text-color-primary);
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  position: absolute;
}
</style>